/** @format */

import React from 'react';

export default function ViewBox({
    useViewBox = true,
    width,
    length,
    x = 0,
    y = 0,
    children,
    ...props
}) {
    if (!useViewBox) {
        // When using a group, just apply a translation to position the content.
        // Note: This component must be rendered inside an existing <svg>.
        return (
            <g transform={`translate(${x}, ${y})`} {...props}>
                {children}
            </g>
        );
    }

    // Otherwise, render an <svg> element with its own viewBox.
    return (
        <svg
            id="Sttark Autogenerated SVG"
            xmlns="http://www.w3.org/2000/svg"
            viewBox={`${x} ${y} ${width} ${length}`}
            width={`${width}in`}
            height={`${length}in`}
            style={{width: '100%', height: '100%'}}
            {...props}>
            {children}
        </svg>
    );
}
